import { Link, Text, TextProps } from '@chakra-ui/react';
import * as React from 'react';

export const Title = React.forwardRef<HTMLDivElement, TextProps>(
  ({ children, ...rest }, ref) => {
    return (
      <Text
        lineHeight="tall"
        fontWeight="semibold"
        fontSize="lg"
        ref={ref}
        {...rest}
      >
        {children}
      </Text>
    );
  }
);
Title.displayName = 'Title';
